<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :footer="footer"
    :methods="methods"
    :config="config"
    @getList="getList"
  >
    <template #componentContainer>
      <order-tracker ref="showSatus" :statusId="statusId"></order-tracker>
    </template>
  </cTable>
</template>

<script>
import { getPacketReport } from "@/api/analysis/packet_report";
// import { getAllClient } from "@/api/user/client";
import orderTracker from "@/base/tracker";
import cTable from "@/base/common/index";
import { getUser } from "@/api/user/internal";
export default {
  name: "packetReport",
  components: {
    cTable,
    orderTracker,
  },
  methods: {
    getList(res) {
      this.fields.forEach((field) => {
        if (field.key === "refundSummary") {
          field.name =
            res.searchForm["startTime"] +
            "~" +
            res.searchForm["endTime"] +
            this.$t("s_package_report");
        }
      });
    },
  },
  data() {
    return {
      statusId: "",
      methods: {
        list: getPacketReport,
        getUser,
      },
      config: {
        height: 630,
        merge: true,
      },
      footer: { show: () => false },
      header: {
        searchs: [
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            default() {
              return this.$page.format.dateFormat(
                new Date().setDate(1),
                "yyyy-MM-dd"
              );
            },
            bind: {
              clearable: false,
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              },
            },
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            default() {
              return this.$page.format.dateFormat(new Date(), "yyyy-MM-dd");
            },
            bind: {
              clearable: false,
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              },
            },
          },
          {
            key: "salesman_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("salesman");
            },
            clearable: true,
            options: [],
            methods: {
              async list({ field }) {
                field.options = (
                  await this.$page.handleRequestMethods("getUser", {
                    standard: "Salesman",
                  })
                ).payload.rows;
                this.$forceUpdate();
              },
            },
            config: { label: "account", value: "id" },
            bind: {
              style: "width:150px",
            },
          },
          {
            key: "accounting_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("accounting");
            },
            clearable: true,
            options: [],
            methods: {
              async list({ field }) {
                field.options = (
                  await this.$page.handleRequestMethods("getUser", {
                    standard: "Accounting",
                  })
                ).payload.rows;
                this.$forceUpdate();
              },
            },
            config: { label: "account", value: "id" },
            bind: {
              style: "width:150px",
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              style: "width:140px",
              type: "textarea",
              rows: 1,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
          ],
          methods: {
            export() {
              console.log(this);
              let data = this.$refs["header"].searchForm;
              console.log(this.$refs["header"].searchForm);
              data["export"] = 1;
              data["startTime"] = this.format.dateFormat(
                data["startTime"],
                "YYYY-MM-DD"
              );
              data["endTime"] = this.format.dateFormat(
                data["endTime"],
                "YYYY-MM-DD"
              );
              this.openLoading();
              this.handleRequestMethods("list", data, false, true).then(
                (res) => {
                  window.open(this.$globalUrl + res.payload.src);
                }
              );
            },
          },
        },
      },
      fields: [
        {
          name: () => this.$t("refundSummary"),
          key: "refundSummary",
          align: "center",
          children: [
            {
              name: () => this.$t("clientName"),
              key: "account",
              align: "left",
              minWidth: 80,
            },
            {
              name: () => this.$t("shipper_company_cn"),
              key: "company",
              align: "left",
              minWidth: 120,
            },
            {
              name: () => this.$t("salesman"),
              key: "salesman",
              align: "left",
              minWidth: 120,
            },
            {
              name: () => this.$t("finances"),
              key: "finance",
              align: "left",
              minWidth: 120,
            },
            {
              name: () => this.$t("account_balances"),
              align: "center",
              children: [
                {
                  name: () => "CNY",
                  key: "cny",
                  align: "left",
                  minWidth: 100,
                },
                {
                  name: () => this.$t("USD"),
                  key: "usd",
                  align: "left",
                  minWidth: 100,
                },
              ],
            },
            {
              name: () => this.$t("paid"),
              align: "center",
              children: [
                {
                  name: () => "CNY",
                  key: "paid_cny",
                  align: "left",
                  minWidth: 100,
                },
                {
                  name: () => this.$t("USD"),
                  key: "paid_usd",
                  align: "left",
                  minWidth: 100,
                },
              ],
            },
            {
              name: () => this.$t("arrears"),
              align: "center",
              children: [
                {
                  name: () => "CNY",
                  key: "arrears_cny",
                  align: "left",
                  minWidth: 100,
                  render: (h, { row }) => {
                    return h(
                      "span",
                      {
                        style: {
                          color: row.arrears_cny > 0 ? "red" : "",
                        },
                      },
                      row.arrears_cny
                    );
                  },
                },
                {
                  name: () => this.$t("USD"),
                  key: "arrears_usd",
                  align: "left",
                  minWidth: 100,
                  render: (h, { row }) => {
                    return h(
                      "span",
                      {
                        style: {
                          color: row.arrears_usd > 0 ? "red" : "",
                        },
                      },
                      row.arrears_usd
                    );
                  },
                },
              ],
            },
          ],
        },
      ],
    };
  },
  mounted() {},
};
</script>
